import Icon from '@ant-design/icons';
import styled from '@emotion/styled';
import { message, Modal, ModalProps, Upload } from 'antd';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { ReactNode, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { batchUpdateStoreAlias } from 'services/api/admin';
import { ReactComponent as excelSvg } from '../assets/excel.svg';

const Title = styled.div`
  background: rgba(215, 225, 250, 1);
  border-radius: 2px;
  padding: 10px 12px;
  color: #515359;
`;

const Flex = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 4px;
  .upload {
    flex: 1;
    svg {
      width: 25px;
      height: 25px;
    }
    .desc {
      margin-top: 8px;
      color: #3370ff;
    }
    .limit {
      margin-top: 6px;
      font-size: 12px;
      color: #b5b9bf;
    }
  }
  .hide {
    .ant-upload.ant-upload-drag {
      display: none;
    }
  }
`;

export interface BatchChangeAliasModalProps extends ModalProps {
  refresh?: () => void;
  exportButton: ReactNode;
}

const BatchUpdateAliasModal = (props: BatchChangeAliasModalProps) => {
  const { refresh, exportButton } = props;
  const [visible, setVisible] = useState(false);
  const [fileList, setFileList] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);
  const sysLang = useSystemLanguageValue();
  const { t } = useTranslate();
  return (
    <>
      <div onClick={() => setVisible(true)}>{t('ViewShops.批量修改别名')}</div>
      <Modal
        title={t('ViewShops.批量修改别名')}
        visible={visible}
        width={568}
        okText={t('ViewShops.确认修改')}
        onCancel={() => {
          setVisible(false);
          setFileList([]);
        }}
        confirmLoading={loading}
        okButtonProps={{ disabled: !fileList.length }}
        destroyOnClose
        onOk={() => {
          const formData = new FormData();
          formData.append('file', fileList[0]);
          setLoading(true);

          batchUpdateStoreAlias(formData)
            .then(() => {
              setVisible(false);
              setFileList([]);
              refresh?.();
              message.success(t('ViewShops.更新成功'));
            })
            .catch((err) => {
              try {
                const msg = JSON.parse(err.response.data.msg);
                const lang = sysLang === 'zh-CN' ? 'zh-CN' : 'en-US';
                const errText =
                  msg.find((x: any) => x.language === lang).msg || t('ViewShops.更新失败');
                message.error(errText);
              } catch (error) {
                message.error(t('ViewShops.更新失败'));
              }
            })
            .finally(() => {
              setLoading(false);
            });
        }}
      >
        <Title>{t('ViewShops.需先导出店铺列表文件，编辑文件后上传即可批量修改店铺别名')}</Title>
        <div className="flex items-center justify-between mt-[4px]">
          <span>{t('ViewShops.上传文件')}</span>
          <div className="flex justify-end mr-[-14px]">{exportButton}</div>
        </div>
        <Flex>
          <div className={`upload ${!fileList.length ? ' ' : 'hide'}`}>
            <Upload.Dragger
              accept=".xlsx,.xls"
              maxCount={1}
              listType="picture"
              beforeUpload={(file) => {
                setFileList([file]);
                return false;
              }}
              onRemove={() => setFileList([])}
              iconRender={() => <Icon component={excelSvg} />}
            >
              <Icon component={excelSvg} />
              <div className="desc">{t('ViewShops.点击或者将文件拖拽到此区域上传')}</div>
              <div className="limit">{t('ViewShops.限1个文件，文件拓展名为.xlsx .xls')}</div>
            </Upload.Dragger>
          </div>
        </Flex>
      </Modal>
    </>
  );
};
export default BatchUpdateAliasModal;
